import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useRequestNavigation, useRequestStore } from '@liscio/common';
import { Button } from '@liscio/ui';

import { MarkCompleteRequestDialog } from 'modules/requests/dialogs/MarkCompleteRequestDialog/MarkCompleteRequestDialog';
import { SMART_TAX_TAB } from 'modules/smart-tax/hooks/useSmartTaxStore';
import { routes } from 'routes';

export type MarkCompleteButtonProps = {
  requestId: string;
};

export const MarkCompleteButton = ({ requestId }: MarkCompleteButtonProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { goBackUrl } = useRequestStore();
  const { isTaxDeliveryRequest } = useRequestNavigation();

  const defaultBackUrl = isTaxDeliveryRequest
    ? routes.smartTax.link(SMART_TAX_TAB.DELIVERY_REQUESTS)
    : routes.requestsListProtected.link();

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        disabled={false}
        variant="contained"
      >
        Mark Complete
      </Button>
      <MarkCompleteRequestDialog
        open={open}
        onClose={() => setOpen(false)}
        requestId={requestId}
        onSuccessfulComplete={() => {
          navigate(goBackUrl || defaultBackUrl);
        }}
      />
    </>
  );
};
